"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectAffirmCheckoutData = exports.selectAffirmLineItems = exports.buildAffirmLineItem = void 0;
const transformObject_1 = __importDefault(require("@simplisafe/ewok/transformObject"));
const monda_1 = require("@simplisafe/monda");
const always_1 = __importDefault(require("ramda/src/always"));
const prop_1 = __importDefault(require("ramda/src/prop"));
const cart_1 = require("../commercetools/cart");
const locale_1 = require("../commercetools/locale");
const constants_1 = require("../constants");
const select_1 = require("../redux/select");
const utils_1 = require("../redux/utils");
// Exported for testing
exports.buildAffirmLineItem = (0, transformObject_1.default)({
    display_name: utils_1.getProductName,
    qty: (0, prop_1.default)('quantity'),
    sku: (0, prop_1.default)('lineItemId'),
    unit_price: lineItem => (lineItem.totalPrice / lineItem.quantity) * 100 // Affirm needs price in cents, so multiply by 100
});
// Exported for testing
const selectAffirmLineItems = (state) => {
    const lineItems = (0, select_1.selectCart)(state).chain((0, monda_1.safeProp)('lineItems'));
    return lineItems.map((0, cart_1.getCartDetails)([]))
        .map(_lineItems => _lineItems
        .filter(lineItem => {
        return (0, prop_1.default)('productType', lineItem) !== constants_1.ProductTypes.Service;
    })
        .map(lineItem => {
        return (0, exports.buildAffirmLineItem)(lineItem);
    }))
        .orJust([]);
};
exports.selectAffirmLineItems = selectAffirmLineItems;
const buildAffirmCheckoutData = (lineItems, additionalAffirmInfo) => (0, transformObject_1.default)({
    financing_program: (0, always_1.default)((0, prop_1.default)('financingProgram', additionalAffirmInfo || {})),
    items: (0, always_1.default)(lineItems),
    merchant: (0, always_1.default)({
        merchant: 'SimpliSafe, Inc.',
        user_cancel_url: `https://${locale_1.LOCALE_INFO.site}`,
        user_confirmation_url: `https://${locale_1.LOCALE_INFO.site}`,
        user_confirmation_url_action: 'GET'
    }),
    metadata: (0, always_1.default)({ mode: 'modal' }),
    shipping: _cart => (0, prop_1.default)('shippingAddress', _cart)
        .map((0, transformObject_1.default)({
        address: _address => ({
            city: (0, prop_1.default)('city', _address),
            country: (0, prop_1.default)('country', _address),
            line1: (0, prop_1.default)('streetName', _address),
            line2: (0, prop_1.default)('additionalStreetInfo', _address),
            state: (0, prop_1.default)('state', _address),
            zipcode: (0, prop_1.default)('postalCode', _address)
        }),
        email: (0, prop_1.default)('email'),
        name: _address => ({
            first: (0, prop_1.default)('firstName', _address),
            last: (0, prop_1.default)('lastName', _address)
        }),
        phone_number: (0, prop_1.default)('phone')
    }))
        .orJust({}),
    total: _cart => Math.round((0, prop_1.default)('totalPrice', _cart) * 100) // Affirm needs price in cents, so multiply by 100
});
/**
 * Select an Affirm checkout object based on the cart's current line items and shipping info data. Returns None if there is no cart or the cart has no shipping address info.
 *
 * @see {@link https://docs.affirm.com/affirm-developers/docs/create-a-checkout-object}
 */
const selectAffirmCheckoutData = (state, additionalAffirmInfo) => {
    const cart = (0, select_1.selectCart)(state);
    const affirmLineItems = (0, exports.selectAffirmLineItems)(state);
    return cart
        .filter(_cart => (0, prop_1.default)('shippingAddress', _cart).isSome())
        .map(buildAffirmCheckoutData(affirmLineItems, additionalAffirmInfo))
        .toMaybe();
};
exports.selectAffirmCheckoutData = selectAffirmCheckoutData;
//# sourceMappingURL=index.js.map